const page_404 = {
	description: "The page you were looking for could not be found.",
	home_button: "Go to the homepage",
	title: "404 Error",
};

export default page_404;
